import { __read } from "tslib";
import { useState } from 'react';
import { getDateWithTime } from './utils';
export function useDateRangePickerState(props) {
    var onChange = props.onChange, _a = props.value, value = _a === void 0 ? { start: null, end: null } : _a;
    var _b = __read(useState(false), 2), isOpen = _b[0], setOpen = _b[1];
    function handleSetValue(event) {
        if (isOpen && event.value.start && event.value.end) {
            setOpen(false);
        }
        if (event.value.start && value.start) {
            event.value.start = getDateWithTime(event.value.start, value.start);
        }
        if (event.value.end && value.end) {
            event.value.end = getDateWithTime(event.value.end, value.end);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange({ value: event.value });
    }
    return {
        value: value,
        setValue: handleSetValue,
        isOpen: isOpen,
        setOpen: setOpen,
    };
}
